module.exports = __webpack_public_path__ + "img/Huang_Huang.5d359211.png";